import { Component, OnInit, ViewEncapsulation, Input, ViewChild, EventEmitter, Output, ElementRef } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '@app/services/toast.service';

import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

import { Attachment } from '@app/models/attachment.model';
import { saveAs } from 'file-saver';
// import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { AuthService } from '@app/core/auth/_services/auth.service';


@Component({
  selector: 'app-file-manager',
  templateUrl: './file-manager.component.html',
  styleUrls: ['./file-manager.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class FileManagerComponent<T extends Attachment> implements OnInit {
  @ViewChild('fileInInput') fileInInput: ElementRef = null;
  @ViewChild('fileOutInput') fileOutInput: ElementRef = null;

  @Input() customParams: any;

  @Input() createAttachment: (attachment: Attachment, customParams?) => T;
  @Input() postFile: (file: T) => Observable<T>;
  @Input() downloadFile: (fileId: number) => Observable<HttpResponse<Blob>>;

  @Input() defaultTab = 0;
  @Input() permission = true;
  @Input() permissionManageOutFiles = false;
  @Input() permissionManageInFiles = false;
  @Input() permissionDeleteInFiles = false;
  @Input() permissionDeleteOutFiles = false;
  @Input() permissionViewOutDocument = false;
  @Input() permissionViewInDocument = false;
  @Input() outputFilesDisabled = true;
  private innerAttachments: T[] = [];
  @Input() set attachments(value: T[]) {
    if (value && value.length > 0) {

      value.forEach(item => {
        item.fileSizeFormatted = this.formatBytes(item.fileSize);
        this.dataSourceFiles.data.push(item);
      });
      this.dataSourceFiles.data = [...this.dataSourceFiles.data];
      this.innerAttachments = value;
    } else {
      this.innerAttachments = [];
    }
  }

  @Input() allowedExtensions: Array<string>;
  showDownloadAllFiles = false;
  showDownloadAllInFiles = false;
  showDownloadAllOutFiles = false;

  @Output() keep = new EventEmitter<boolean>();
  @Output() files = new EventEmitter<T[]>();
  @Output() disabledAction = new EventEmitter<boolean>();
  keepFiles: FormControl;

  // Para interactuar con pestaña Adjuntos de Salida
  // isOutSelected = false;

  displayedFilesColumns: string[] = ['icon', 'name', 'action'];

  dataSourceFiles = new MatTableDataSource<T>();

  selectedFile: File;
  spinnerDisplay = false;
  filesToBeAttached: { [id: number]: T } = {};

  user;
  private oneMB = 1048576; // 1 MB
  private maxSize: number;
  extensions = '';

  filesQueue = 0;
  filesProcessed = 0;

  constructor(
    public dialog: MatDialog,
    private toast: ToastService,
    // private progressService: FuseProgressBarService,
    private translateService: TranslateService,
    private auth: AuthService,
  ) {
    this.user = auth.currentUser;
  }

  ngOnInit() {
    if (this.user.maxFileSizeUpload &&
      this.user.maxFileSizeUpload != null &&
      this.user.maxFileSizeUpload !== undefined &&
      typeof this.user.maxFileSizeUpload === 'number') {
      this.maxSize = this.oneMB * this.user.maxFileSizeUpload;
    } else {
      this.maxSize = this.oneMB * 20;
    }

    if (this.allowedExtensions &&
      this.allowedExtensions.length) {
      this.allowedExtensions.forEach((item, index) => {
        this.extensions += index + 1 === this.allowedExtensions.length ? '.' + item : '.' + item + ', ';
      });
    }

    this.keepFiles = new FormControl({ value: false, disabled: !this.permission });

    // if (this.consultationId && this.consultationId > 0) {
    //   this.showDownloadAllFiles = true;
    // }

    /* if (this.attachments && this.attachments.length > 0) {
 
       this.attachments.forEach(item => {
         item.fileSizeFormatted = this.formatBytes(item.fileSize);
         if (item.direction === 'IN') {
           // Commented because there is no endpoint for downloading All items
           // this.showDownloadAllInFiles = true;
           this.dataSourceFilesInput.data.push(item);
         }
         if (item.direction === 'OUT') {
           // Commented because there is no endpoint for downloading All items
           // this.showDownloadAllOutFiles = true;
           this.dataSourceFilesOutput.data.push(item);
         }
       });
     } else {
       this.attachments = [];
     }*/

    this.keepFiles.valueChanges.subscribe(value => {
      this.keep.emit(value);
    });
  }

  onClickFileInput(direction: string) {
    if (direction === 'IN') {
      this.fileInInput.nativeElement.click();
    } else {
      this.fileOutInput.nativeElement.click();
    }
  }

  onFileInUpload(files: File[]) {
    this.onFileUpload(files, 'IN');
    if (this.fileInInput &&
      this.fileInInput !== undefined) {
      this.fileInInput.nativeElement.value = null;
    }
  }

  onFileOutUpload(files: File[]) {
    this.onFileUpload(files, 'OUT');
    if (this.fileOutInput &&
      this.fileOutInput !== undefined) {
      this.fileOutInput.nativeElement.value = null;
    }
  }

  onFileUpload(files: File[], dir: 'IN' | 'OUT') {
    if (files && files.length > 0) {

      this.filesQueue += files.length;

      for (const selectedFile of files) {

        if (selectedFile.size < this.maxSize) {
          const reader = new FileReader();
          reader.readAsDataURL(selectedFile);
          reader.onload = () => {
            const fileExtension = selectedFile.name.split('.');
            const newFile = this.createAttachment({
              id: 0,
              name: selectedFile.name,
              fileSize: selectedFile.size,
              fileSizeFormatted: this.formatBytes(selectedFile.size),
              file: (reader.result as string).split(',')[1],
              binaryFile: selectedFile,
              fileExtension: `.${fileExtension[fileExtension.length - 1]}`,
            }, this.customParams);

            if (!newFile.file || newFile.file.length < 1) {
              this.filesProcessed++;
              this.showProcessedFiles();
              this.toast.warning(this.translateService.instant('FILE-MANAGER.TABLE.FILE-EMPTY'));
            } else {
              this.postFileApi(newFile, dir);
            }
          };
        } else {
          this.filesProcessed++;
          this.showProcessedFiles();
          this.toast.warning(this.translateService.instant('FILE-MANAGER.TABLE.FILE-MAXSIZE', { maxSize: this.formatBytes(this.maxSize) }));
        }
      }
    } else {
      this.toast.warning(this.translateService.instant('FILE-MANAGER.TABLE.FILE-NOTEXIST'));
    }
  }

  updateDataSources(newRow: T, dir: 'IN' | 'OUT') {
    const dataSource = this.dataSourceFiles;
    dataSource.data = [...dataSource.data, newRow];
    this.toast.success(this.translateService.instant('FILE-MANAGER.TABLE.ATT-SUCCES'));
    this.innerAttachments.push(newRow);
    this.files.emit(this.innerAttachments);
  }

  dropRow(row: T, dir: 'IN' | 'OUT') {
    const dataSource = this.dataSourceFiles;
    dataSource.data = this.arrayRemove(dataSource.data, row);
    this.toast.success(this.translateService.instant('FILE-MANAGER.TABLE.ATT-DROP'));
    this.innerAttachments = this.arrayRemove(this.innerAttachments, row);
    this.files.emit(this.innerAttachments);
  }

  arrayRemove<T>(arr: T[], value: T) {
    return arr.filter(ele => ele !== value);
  }

  postFileApi(file: T, dir: 'IN' | 'OUT') {
    this.spinnerDisplay = true;
    this.disabledAction.emit(true);
    this.postFile(file).subscribe(response => {
      this.disabledAction.emit(false);
      const newRow: T = { ...file, id: response.id };
      this.filesToBeAttached[response.id] = file;

      this.updateDataSources(newRow, dir);

      this.filesProcessed++;
      this.showProcessedFiles();
    },
      err => this.spinnerDisplay = false);
  }

  showProcessedFiles(): void {
    if (this.filesQueue === this.filesProcessed) {
      this.filesQueue = this.filesProcessed = 0;
      this.spinnerDisplay = false;
    }
  }

  getFileById(fileId: number) {
    if (fileId > 0) {
      if (this.filesToBeAttached.hasOwnProperty(fileId)) {
        const file = this.filesToBeAttached[fileId];
        this.saveFile(file.binaryFile);
      } else {
        // this.progressService.show();
        this.downloadFile(fileId).subscribe(res => {
          const array = res.headers.get('content-disposition').split(';');
          let fileName = array.find(x => x.startsWith(" filename*=UTF-8''")).trim().replace("filename*=UTF-8''", '').replace(/"/g, '');
          fileName = decodeURI(fileName);

          this.saveFile(res.body, fileName, res.body.type);
          // this.progressService.hide();
        },
          (err) => { 
            this.toast.error(err);
            //this.progressService.hide();
          });
      }
    } else {
      this.toast.success(this.translateService.instant('FILE-MANAGER.TABLE.FILE-NOTEXIST'));
    }
  }

  downloadAllFiles(type: string) {
    // if (this.showDownloadAllFiles) {
    //   this.consultationService.downloadAllFiles(this.consultationId).subscribe(response => {
    //     // if (type === 'IN') {
    //     //   this.downloadFile(response, this.translateService.instant('FILE-MANAGER.TABS.IN') + '.zip', response.type);
    //     // }
    //     // if (type === 'OUT') {
    //     //   this.downloadFile(response, this.translateService.instant('FILE-MANAGER.TABS.OUT') + '.zip', response.type);
    //     // }
    //   },
    //     (err) => this.toast.error(err));
    // }
  }

  saveFile(data: Blob, fileName?: string, fileType?: string) {
    if (fileName) {
      // fileName = fileName.replace(/\./g, '_');
      const blob = new Blob([data], { type: fileType });
      saveAs(blob, fileName);
    } else {
      saveAs(data);
    }
  }

  // FileSize Format Func
  formatBytes(bytes: number) {
    if (!bytes) { return '-'; }
    const decimals = 2;
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}
